'use client';

import { useEffect, useRef } from 'react';
import { useIsClient } from 'usehooks-ts';

declare global {
  // eslint-disable-next-line ts/consistent-type-definitions
  interface Window {
    gtag?: (
      command: string,
      event: string,
      params?: {
        send_to?: string;
        value?: number;
        currency?: string;
      },
    ) => void;
  }
}

export function GoogleConversionTracker() {
  const isClient = useIsClient();
  const hasTracked = useRef(false);

  useEffect(() => {
    if (!isClient || hasTracked.current) {
      return;
    }

    const trackConversion = () => {
      if (window.gtag && !hasTracked.current) {
        window.gtag('event', 'conversion', {
          send_to: 'AW-17275495042/Sign-up',
          value: 1.0,
          currency: 'GBP',
        });
        hasTracked.current = true;
      }
    };

    // Try immediately
    trackConversion();

    // If gtag isn't available yet, set up an interval to retry
    if (!hasTracked.current) {
      const intervalId = setInterval(() => {
        trackConversion();
        if (hasTracked.current) {
          clearInterval(intervalId);
        }
      }, 100);

      // Clean up after 10 seconds if still not tracked
      const timeoutId = setTimeout(() => {
        clearInterval(intervalId);
      }, 10000);

      return () => {
        clearInterval(intervalId);
        clearTimeout(timeoutId);
      };
    }

    return undefined;
  }, [isClient]);

  return null;
}
